import { SuppliersActions, SuppliersUnion } from '../actions/suppliers.actions';

export interface SuppliersState {
    data: any;
    currentPage: number;
    lastPage: number;
    perPage: number;
    total: number;
    error: any;
}

export const initialState: SuppliersState = {
    data: [],
    currentPage: null,
    lastPage: null,
    perPage: null,
    total: null,
    error: null
};

/**
 * @deprecated will be deleted
 */

export function reducer(state = initialState, action: SuppliersUnion): SuppliersState {
    switch (action.type) {
        case SuppliersActions.FetchSuppliersSuccess: {
            if (
                action.payload?.current_page &&
                action.payload?.last_page &&
                action.payload?.per_page &&
                action.payload?.total
            ) {
                return {
                    data: action.payload.data,
                    currentPage: action.payload.current_page,
                    lastPage: action.payload.last_page,
                    perPage: action.payload.per_page,
                    total: action.payload.total,
                    error: null
                };
            } else {
                return {
                    data: action.payload,
                    currentPage: null,
                    lastPage: null,
                    perPage: null,
                    total: null,
                    error: null
                };
            }
        }
        case SuppliersActions.AddSupplierFail: {
            return {
                ...state,
                error: action.payload
            };
        }
        default: {
            return state;
        }
    }
}
